import type { User } from '../utils/types';

const LANDING_PRIORITY = [
  '/dashboard',
  '/jobs',
  '/production',
  '/production-line',
  '/quotes',
  '/users',
];

export function bypassesPageAccess(user: User | null): boolean {
  if (!user) return false;
  if (user.is_superuser || user.is_staff) return true;
  if (isDeliveryUser(user)) return true;
  return false;
}

export function isDeliveryUser(user: User | null): boolean {
  return user?.role?.toLowerCase() === 'delivery';
}

/**
 * Returns true if pathname is allowed for the user.
 * `visible_page_paths` is computed on the server (intersection of role pages + permissions).
 */
export function isPathAllowedForUser(pathname: string, user: User | null): boolean {
  if (!user) return false;
  if (bypassesPageAccess(user)) return true;
  const allowed = user.visible_page_paths ?? [];
  if (allowed.length === 0) return false;
  return allowed.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function getDefaultLandingPath(user: User | null): string {
  if (isDeliveryUser(user)) return '/jobs';
  if (!user) return '/dashboard';
  if (bypassesPageAccess(user)) return '/dashboard';
  const paths = user.visible_page_paths ?? [];
  if (paths.length === 0) return '/dashboard';
  for (const p of LANDING_PRIORITY) {
    if (paths.includes(p)) return p;
  }
  return paths[0];
}
